import { useCachedResource } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { rides } from "../local/db";

// #642 — the whole ring's rides for the show, in ONE call (#637 added the
// showId/day/ring filter to GET /ride, backed by the existing ridesByShow GSI).
// Before that this would have been one request per class — 40 round trips over
// venue wifi on every refresh.
//
// NOTE the generated client puts classId FIRST:
//   listRides(classId, showId, day, ring, needsReview, riderId, horseId)
// so a ring query is listRides(undefined, showId, undefined, ring).
//
// The local `rides` store is keyed by id and indexed by classId only, so the
// cache read filters on ring itself — prefetchDay bulk-puts without clearing, so
// a ring change mid-day can leave another ring's rides behind.
// `nonce` is the slow entity-refresh beat: bump it to force a revalidate (a
// scratch adds/removes rows, and only a re-fetch will show it).
export function useRidesForRing(showId, ring, online, nonce = 0) {
  const api = useScoreApi();
  return useCachedResource(
    async () => {
      if (!showId || !ring) return undefined;
      const cached = (await rides.getAll()).filter(
        (r) => r.showId === showId && String(r.ring) === String(ring),
      );
      return cached.length ? cached : undefined;
    },
    async () => {
      if (!showId || !ring) return [];
      const list = unwrap(await api.rides.listRides(undefined, showId, undefined, ring));
      await rides.putAll(list ?? []);
      return list ?? [];
    },
    [api, showId, ring, nonce],
    online,
  );
}

export default useRidesForRing;
